import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Amplify } from "aws-amplify";
import styled from "@emotion/styled/macro";
import { Global, css } from "@emotion/react";
import { SWRConfig } from "swr";
import { ErrorBoundary } from "react-error-boundary";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { App } from "./App";
import awsconfig from "./aws-exports";
import { ErrorPage } from "./components/pages/ErrorPage";
import "providers/rollbar";
import { initFullstory } from "./services/fullstory";
import { COGNITO_CONFIG } from "cognitoConfig";
import { rollbar } from "providers/rollbar";

initFullstory();
const env = getEnvironment();

Amplify.configure(awsconfig);
const existingConfig = Amplify.getConfig();
Amplify.configure({ ...existingConfig, ...COGNITO_CONFIG[env] });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const Container = styled.div`
  font-family: "Roobert", sans-serif;
  width: 100%;
`;

root.render(
  <Container>
    <Global
      styles={css`
        @import url("https://fonts.cdnfonts.com/css/roobert");
        @import url("https://fonts.cdnfonts.com/css/sf-pro-display");
        fieldset {
          border: none;
          font-family: "Roobert", sans-serif;
        }
      `}
    />
    <SWRConfig //see https://swr.vercel.app/docs/api#options
      value={{
        errorRetryCount: 2,
        revalidateOnFocus: false,
      }}
    >
      <ErrorBoundary fallback={<ErrorPage />} onError={rollbar.critical}>
        <App />
      </ErrorBoundary>
    </SWRConfig>
  </Container>
);
